import lang from '../languages/en.json';
import { LineGraphModel } from '../models/LineGraphModels';
import { formatDateRange, formatMonthYearRange } from './appUtils';

/**
 * Performance analysis data structure
 */
export interface PerformanceAnalysis {
  /** Analysis description of current performance */
  analysis: string;
  /** Recommendations for improvement */
  recommendations: string;
}

/**
 * Get performance analysis based on KPI category
 * Provides standardized performance insights and recommendations
 *
 * @param category - The KPI category to analyze
 * @returns Performance analysis object with insights and recommendations
 */
export const getPerformanceAnalysis = (category: string): PerformanceAnalysis => {
  const categoryKey = category.toLowerCase();
  const analysisData = lang.performanceAnalysis[categoryKey] || lang.performanceAnalysis.default;

  return {
    analysis: analysisData.analysis,
    recommendations: analysisData.recommendations,
  };
};

export const getDateRange = (kpi?: LineGraphModel): string | undefined => {
  return kpi ? formatDateRange(kpi.pointOfSaleDate) : undefined;
};

export const getTrendIndicator = (kpi?: LineGraphModel) => {
  if (!kpi) return undefined;
  return {
    value: kpi.differenceAmount,
    percentage: kpi.differencePercent,
  };
};

export const getMonthYearRange = (kpi?: LineGraphModel): string | undefined => {
  return kpi ? formatMonthYearRange(kpi.pointOfSaleDate) : undefined;
};

